import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  StyledInputWrapper,
  StyledInput,
  StyledTextarea,
  StyledError,
} from './StyledInput';

const Input = ({
  label = false,
  onChange,
  onBlur,
  name,
  type,
  value,
  errorMessage = false,
}) => {
  const [hasContent, setContent] = useState(false);

  const handleInputChange = e => {
    onChange(e);
    if (e.target.value) {
      setContent(true);
    } else {
      setContent(false);
    }
  };
  return (
    <StyledInputWrapper isError={errorMessage || hasContent}>
      {errorMessage && <StyledError> {errorMessage}</StyledError>}

      {type === 'textarea' ? (
        <StyledTextarea
          name={name}
          rows="4"
          value={value}
          id={name}
          onChange={e => handleInputChange(e)}
          onBlur={e => onBlur(e)}
          placeholder={`${label} *`}
        />
      ) : (
        <StyledInput
          name={name}
          type={type}
          value={value}
          id={name}
          onChange={e => handleInputChange(e)}
          onBlur={e => onBlur(e)}
          placeholder={`${label} ${name === 'companyName' ? '' : '*'}`}
        />
      )}
    </StyledInputWrapper>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    'text',
    'textarea',
    'number',
    'hidden',
    'tel',
    'date',
    'email',
    'month',
    'time',
    'week',
    'password',
    'url',
  ]).isRequired,
  value: PropTypes.string.isRequired,
};

Input.defaultProps = {
  label: null,
  errorMessage: '',
};

export default Input;
